import React from 'react';
import './TourCard.css';

import exp1 from '../assets/experience-1.png';
import exp2 from '../assets/experience-2.png';
import exp3 from '../assets/experience-3.png';
import exp4 from '../assets/experience-4.jpg';

const imageMap = {
  'experience-1.png': exp1,
  'experience-2.png': exp2,
  'experience-3.png': exp3,
  'experience-4.jpg': exp4,
};

function TourCard({ image, country, title, price, rating }) {
  const resolvedImage = imageMap[image] || image;

  return (
    <div className="tour-card" style={{ backgroundImage: `url(${resolvedImage})` }}>
      <div className="card-content">
        <div className="card-location">{country}</div>
        <h3 className="card-title">{title}</h3>
        <div className="card-footer">
          {price && <span className="card-price">от ${price}</span>}
          {rating && <span className="card-rating">★ {rating}</span>}
        </div>
      </div>
    </div>
  );
}

export default TourCard;
